module.exports = __webpack_public_path__ + "static/media/1006148.bc30b393.png";